'use client';

import ModalMap from '@/components/map/component/modal-map';
import { MainSection } from '@/components/section/main';
import { useCustomContext } from '@/contexts/contextCreator';
import { useMapStore } from '@/stores/map/mapStore';
import { usePageTheme } from '@/stores/page-theme';
import { MRCOOL } from '@/utils/constants';
import { useEffect } from 'react';
import { useStore } from 'zustand';

const Page = () => {
  const { value } = useCustomContext();
  const landingPage = value as any;
  const { setPageTheme } = useStore(usePageTheme, (state) => ({
    setPageTheme: state.setPageTheme,
  }));
  const { modalMapOpen, setModalMapOpen } = useStore(useMapStore, (state) => ({
    modalMapOpen: state.modalMapOpen,
    setModalMapOpen: state.setModalMapOpen,
  }));

  useEffect(() => {
    setPageTheme(landingPage?.pageTheme || 'default');

    document.title = `${landingPage?.overview_meta_title ? `${landingPage?.overview_meta_title} | ${MRCOOL}` : MRCOOL}`;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `${landingPage?.overview_meta_description ? `${landingPage?.overview_meta_description}` : 'Meta Description'}`
      );
    }
  }, [landingPage, setPageTheme]);

  return (
    <>
      <MainSection data={landingPage as any} />
      <ModalMap mapOpen={modalMapOpen} setMapOpen={setModalMapOpen} />
    </>
  );
};

export default Page;
